'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../index');

var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);

var _ShareButton = require('./ShareButton.scss');var styles = _interopRequireWildcard(_ShareButton);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // helpers
// global
var ShareButton = function ShareButton(_ref)












{var id = _ref.id,locale = _ref.locale,isProject = _ref.isProject,translate = _ref.translate,isNative = _ref.isNative,shareLinkClassName = _ref.shareLinkClassName,isToolbar = _ref.isToolbar,_ref$iconLinkShareCla = _ref.iconLinkShareClass,iconLinkShareClass = _ref$iconLinkShareCla === undefined ? 'icon icon-contacts-share-fill' : _ref$iconLinkShareCla,onShare = _ref.onShare,additionalToolbarBtnClassName = _ref.additionalToolbarBtnClassName,formatShareData = _ref.formatShareData,shareBlockClassName = _ref.shareBlockClassName;
  var target = isProject ? 'project' : 'home';
  var sharingUrl = (0, _makeSharingUrl2.default)('/' + target + '_details/' + id, locale);
  var protocol = sharingUrl.includes('://') ? '' : 'https://';
  var fullUrl = '' + protocol + sharingUrl + '/open_share';

  if (isNative) {
    return (
      _react2.default.createElement('a', {
          href: fullUrl,
          target: '_blank',
          className: shareLinkClassName },

        _react2.default.createElement('span', { className: iconLinkShareClass }),
        !isToolbar && _react2.default.createElement('span', null, translate('propertyDetails', 'shareTitle'))));


  }

  if (isToolbar) {
    return (
      _react2.default.createElement('p', {
          onClick: onShare,
          className: additionalToolbarBtnClassName },

        _react2.default.createElement('i', { className: 'icon icon-export' })));


  }

  return (
    _react2.default.createElement(_index.ShareBlock, {
      locale: locale,
      translate: translate,
      sharingData: formatShareData,
      copyLinkTitle: '' + translate('copyLink'),
      emailTitle: '' + translate('propertyDetails', 'contacts', 'email'),
      className: shareBlockClassName,
      sizeIcon: 24,
      iconFill: true }));


}; // styles
// components
ShareButton.propTypes = {
  id: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  isNative: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  isProject: _propTypes2.default.string,
  isToolbar: _propTypes2.default.bool,
  formatShareData: _propTypes2.default.func,
  wrapperTag: _propTypes2.default.string,
  onShare: _propTypes2.default.func,
  additionalToolbarBtnClassName: _propTypes2.default.object,
  shareLinkClassName: _propTypes2.default.string,
  iconLinkShareClass: _propTypes2.default.string,
  shareBlockClassName: _propTypes2.default.string };exports.default =


ShareButton;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareButton/ShareButton.js
// module id = 2920
// module chunks = 0